import { useSyncExternalStore } from 'react';

let revision = 0;
const listeners = new Set<() => void>();
function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
export function notifyUomsChanged(): void {
  revision += 1;
  listeners.forEach((listener) => listener());
}
export function useUomRevision(): number {
  return useSyncExternalStore(subscribe, () => revision);
}
